<script lang="ts">
	import Time from '@icons/Time.svelte';
	import Drink from '@icons/Drink.svelte';
	import Location from '@icons/Location.svelte';
	import Ticket from '@icons/Ticket.svelte';
	import Coatcheck from '@icons/Coatcheck.svelte';
	import Info from '@icons/Info.svelte';

	let {
		name
	}: {
		name: string;
	} = $props();
</script>

{#if name.toLowerCase().includes('tider')}
	<Time />
{:else if name.toLowerCase().includes('drikke') || name.toLowerCase().includes('mad')}
	<Drink />
{:else if name.toLowerCase().includes('vej') || name.toLowerCase().includes('parkering')}
	<Location />
{:else if name.toLowerCase().includes('billet')}
	<Ticket />
{:else if name.toLowerCase().includes('garderobe')}
	<Coatcheck />
{:else if name.toLowerCase().endsWith('?')}
	<Info />
{/if}
